import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

/** 与导出、列表接口共用的闲置风险档，单位：无动态天数 */
export const INACTIVE_RISK_DAYS = {
    high: 90,
    medium: 60,
    low: 7,
};

export function classifyInactiveRisk(days) {
    if (days === null || days === undefined) {
        return "unknown";
    }
    if (days >= INACTIVE_RISK_DAYS.high) {
        return "high";
    }
    if (days >= INACTIVE_RISK_DAYS.medium) {
        return "medium";
    }
    if (days >= INACTIVE_RISK_DAYS.low) {
        return "low";
    }
    return "normal";
}

export function daysSinceLastMoveUtc(lastMovedAt, now = dayjs.utc()) {
    if (!lastMovedAt) {
        return null;
    }
    return dayjs.utc(now).diff(dayjs.utc(lastMovedAt), "day");
}

export function applyInactiveTableQuery(rows, { filters = {}, sorter } = {}) {
    const riskFilter = filters.riskLevel;
    const allowedRisk = Array.isArray(riskFilter) && riskFilter.length > 0 ? new Set(riskFilter) : null;

    let next = allowedRisk ? rows.filter((row) => allowedRisk.has(row.riskLevel)) : [...rows];

    if (sorter?.field === "daysSinceLastMove" && sorter.order) {
        const direction = sorter.order === "ascend" ? 1 : -1;
        next = [...next].sort((a, b) => {
            const left = a.daysSinceLastMove === null || a.daysSinceLastMove === undefined ? Number.POSITIVE_INFINITY : a.daysSinceLastMove;
            const right = b.daysSinceLastMove === null || b.daysSinceLastMove === undefined ? Number.POSITIVE_INFINITY : b.daysSinceLastMove;
            return (left - right) * direction;
        });
    }

    return next;
}
